let contentTypeSelect = document.querySelector<HTMLSelectElement>('[data-contenttype]');

export function initContentType() {
  // ensure we have a reference (in case DOM wasn't ready when module loaded)
  if (!contentTypeSelect) {
    contentTypeSelect = document.querySelector<HTMLSelectElement>('[data-contenttype]');
  }
  if (!contentTypeSelect) return;

  // collect option values that correspond to container ids
  const optionValues = Array.from(contentTypeSelect.options)
    .map(o => `${o.value}DataContainer`)
    .filter(Boolean);

  const updateVisibility = () => {
    const selectedValue = `${contentTypeSelect!.value}DataContainer` ;
    for (const val of optionValues) {
      const container = document.getElementById(val);
      if (!container) continue;
      if (val === selectedValue) {
        container.classList.remove('hidden');
      } else {
        container.classList.add('hidden');
      }
    }
  };

  // run once to set initial state then listen for changes
  updateVisibility();
  contentTypeSelect.addEventListener('change', updateVisibility);
}

initContentType();
